// this file is automatically generated by git.version.ts script
export const versions = {date: 1789135098422, version: '4.5.0.ccfff71', revision: 'ccfff71a3634ac39b882809adc92c680a56c2947', branch: 'feature/WORK-792'};